import script from "./addMeta.vue?vue&type=script&setup=true&lang=ts"
export * from "./addMeta.vue?vue&type=script&setup=true&lang=ts"

import "./addMeta.vue?vue&type=style&index=0&id=11ae79b9&lang=scss"

const __exports__ = script;

export default __exports__